import { sbxCoreService} from '../Network';
import Address from "../Models/Address";
import {ISearchAddressParams} from "../Store/Address/Types";
const MODEL = "address"

export function getAddressByKey(key: string) {
  return sbxCoreService.with(MODEL)
    .whereWithKeys([key])
    .fetchModels(["city", "zone"])
    .loadAll();
}

export function getAddresses(criteria?: ISearchAddressParams) {
  let query =  sbxCoreService.with(MODEL)
  if (criteria && criteria.customer) {
    query = query.andWhereIsEqualTo("customer", criteria.customer);
  }
  return query.fetchModels(["city", "zone"])
  .loadAll();
}

export function saveAddress(address: Address) {
  if (!address._KEY) {
    return sbxCoreService.with(MODEL)
      .insert(address);
  }

  return sbxCoreService.with(MODEL)
    .update(address);
}

export function deleteAddress(address: Address) {
  return sbxCoreService.with(MODEL)
    .whereWithKeys([address._KEY])
    .delete();
}
